/**
 * Seed data for the BUSCARX project. Both the sheet builder and the grader
 * read from here, so expected answers always match what is in the workbook.
 */

export const SHEETS = {
  catalogo: "BX Catálogo",
  pedidos: "BX Pedidos",
  consultas: "BX Consultas",
} as const;

export const CATALOGO_HEADERS = [
  "SKU",
  "Producto",
  "Categoría",
  "Proveedor",
  "Precio",
  "Stock",
] as const;

// SKU, Producto, Categoría, Proveedor, Precio, Stock
export const CATALOGO: [string, string, string, string, number, number][] = [
  ["TEC-001", "Laptop Pro 14", "Computadoras", "TecnoMax", 24999, 12],
  ["TEC-002", "Laptop Air 13", "Computadoras", "TecnoMax", 18999, 20],
  ["TEC-003", "Mouse inalámbrico", "Periféricos", "Distribuidora Sol", 349, 150],
  ["TEC-004", "Teclado mecánico", "Periféricos", "ImportaYa", 1299, 60],
  ["TEC-005", "Monitor 24 pulgadas", "Monitores", "MegaParts", 3299, 35],
  ["TEC-006", "Monitor 27 pulgadas 4K", "Monitores", "MegaParts", 7499, 18],
  ["TEC-007", "Audífonos con cancelación", "Audio", "ImportaYa", 2899, 40],
  ["TEC-008", "Bocina Bluetooth", "Audio", "Distribuidora Sol", 899, 75],
  ["TEC-009", "Silla ergonómica", "Mobiliario", "OficinaPlus", 4599, 25],
  ["TEC-010", "Escritorio elevable", "Mobiliario", "OficinaPlus", 8999, 10],
  ["TEC-011", "Base para laptop", "Accesorios", "Distribuidora Sol", 499, 90],
  ["TEC-012", "Hub USB-C 7 en 1", "Accesorios", "ImportaYa", 799, 110],
  ["TEC-013", "Cámara web HD", "Periféricos", "MegaParts", 1099, 55],
  ["TEC-014", "Micrófono de condensador", "Audio", "ImportaYa", 1899, 30],
  ["TEC-015", "Teclado ergonómico", "Periféricos", "OficinaPlus", 1599, 28],
  ["TEC-016", "Mouse vertical", "Periféricos", "OficinaPlus", 699, 45],
  ["TEC-017", "Disco SSD 1 TB", "Almacenamiento", "TecnoMax", 1499, 80],
  ["TEC-018", "Disco duro externo 2 TB", "Almacenamiento", "MegaParts", 1399, 64],
  ["TEC-019", "Memoria USB 128 GB", "Almacenamiento", "Distribuidora Sol", 249, 200],
  ["TEC-020", "Tableta gráfica", "Periféricos", "ImportaYa", 2299, 15],
  ["TEC-021", "Impresora láser", "Impresión", "TecnoMax", 3899, 14],
  ["TEC-022", "Tóner negro", "Impresión", "TecnoMax", 1199, 70],
  ["TEC-023", "Router WiFi 6", "Redes", "MegaParts", 1999, 33],
  ["TEC-024", "Switch 8 puertos", "Redes", "MegaParts", 899, 27],
  ["TEC-025", "Cable HDMI 2 m", "Accesorios", "Distribuidora Sol", 199, 300],
  ["TEC-026", "Lámpara LED de escritorio", "Mobiliario", "OficinaPlus", 649, 52],
  ["TEC-027", "Reposapiés ergonómico", "Mobiliario", "OficinaPlus", 899, 22],
  ["TEC-028", "Laptop Gamer 16", "Computadoras", "TecnoMax", 32999, 6],
  ["TEC-029", "Tablet 11 pulgadas", "Computadoras", "ImportaYa", 8499, 19],
  ["TEC-030", "Funda para tablet", "Accesorios", "Distribuidora Sol", 399, 85],
  ["TEC-031", "No-break 1000 VA", "Energía", "MegaParts", 2499, 16],
  ["TEC-032", "Regulador de voltaje", "Energía", "MegaParts", 599, 48],
];

export const PEDIDOS_HEADERS = [
  "Pedido",
  "Fecha",
  "SKU",
  "Cantidad",
  "Vendedor",
  "Producto",
] as const;

// Pedido, Fecha (yyyy-mm-dd), SKU, Cantidad, Vendedor — sorted by date.
export const PEDIDOS: [string, string, string, number, string][] = [
  ["P-1001", "2026-01-05", "TEC-003", 10, "Ana"],
  ["P-1002", "2026-01-06", "TEC-001", 2, "Luis"],
  ["P-1003", "2026-01-08", "TEC-012", 5, "Marta"],
  ["P-1004", "2026-01-09", "TEC-005", 3, "Ana"],
  ["P-1005", "2026-01-12", "TEC-019", 25, "Jorge"],
  ["P-1006", "2026-01-14", "TEC-009", 4, "Luis"],
  ["P-1007", "2026-01-15", "TEC-003", 8, "Sofía"],
  ["P-1008", "2026-01-19", "TEC-023", 2, "Marta"],
  ["P-1009", "2026-01-21", "TEC-007", 6, "Jorge"],
  ["P-1010", "2026-01-23", "TEC-017", 12, "Ana"],
  ["P-1011", "2026-01-27", "TEC-028", 1, "Sofía"],
  ["P-1012", "2026-01-30", "TEC-025", 40, "Luis"],
  ["P-1013", "2026-02-02", "TEC-004", 7, "Marta"],
  ["P-1014", "2026-02-04", "TEC-010", 2, "Jorge"],
  ["P-1015", "2026-02-06", "TEC-013", 9, "Ana"],
  ["P-1016", "2026-02-09", "TEC-003", 15, "Luis"],
  ["P-1017", "2026-02-11", "TEC-021", 1, "Sofía"],
  ["P-1018", "2026-02-13", "TEC-022", 6, "Sofía"],
  ["P-1019", "2026-02-16", "TEC-002", 3, "Marta"],
  ["P-1020", "2026-02-18", "TEC-015", 4, "Jorge"],
  ["P-1021", "2026-02-20", "TEC-031", 2, "Ana"],
  ["P-1022", "2026-02-23", "TEC-008", 10, "Luis"],
  ["P-1023", "2026-02-25", "TEC-001", 1, "Marta"],
  ["P-1024", "2026-02-27", "TEC-029", 3, "Sofía"],
  ["P-1025", "2026-03-02", "TEC-012", 8, "Jorge"],
  ["P-1026", "2026-03-04", "TEC-016", 5, "Ana"],
  ["P-1027", "2026-03-06", "TEC-005", 2, "Luis"],
  ["P-1028", "2026-03-09", "TEC-026", 7, "Marta"],
  ["P-1029", "2026-03-11", "TEC-003", 20, "Sofía"],
  ["P-1030", "2026-03-13", "TEC-018", 4, "Jorge"],
  ["P-1031", "2026-03-16", "TEC-024", 3, "Ana"],
  ["P-1032", "2026-03-18", "TEC-006", 2, "Luis"],
  ["P-1033", "2026-03-20", "TEC-014", 3, "Marta"],
  ["P-1034", "2026-03-23", "TEC-001", 2, "Sofía"],
  ["P-1035", "2026-03-25", "TEC-030", 12, "Jorge"],
  ["P-1036", "2026-03-27", "TEC-011", 6, "Ana"],
];

/** Commission brackets: sales from `desde` earn `pct`. Ascending. */
export const TRAMOS_COMISION: [number, number][] = [
  [0, 0.02],
  [50000, 0.04],
  [100000, 0.06],
  [200000, 0.08],
  [350000, 0.1],
];

/** Vendors whose commission % the student looks up (task 6). */
export const VENTAS_VENDEDORES: [string, number][] = [
  ["Ana", 45000],
  ["Luis", 120000],
  ["Marta", 200000],
  ["Jorge", 99999],
  ["Sofía", 410000],
];

export const REGIONES = ["Norte", "Centro", "Sur"] as const;

// Producto, Norte, Centro, Sur
export const PRECIOS_REGION: [string, number, number, number][] = [
  ["Laptop Pro 14", 25499, 24999, 25999],
  ["Laptop Air 13", 19299, 18999, 19599],
  ["Monitor 24 pulgadas", 3399, 3299, 3449],
  ["Silla ergonómica", 4699, 4599, 4799],
  ["Router WiFi 6", 2049, 1999, 2099],
  ["Tablet 11 pulgadas", 8699, 8499, 8799],
];

/** Inputs the student looks up on "BX Consultas". */
export const CONSULTAS = {
  skuPrecio: "TEC-007",
  skuInexistente: "TEC-099",
  productoParaSku: "Mouse inalámbrico",
  skuDetalle: "TEC-013",
  textoParcial: "ergon",
  skuUltimoPedido: "TEC-003",
  productoRegion: "Laptop Air 13",
  region: "Sur",
} as const;

/** Where each task's answer goes. Task 2 and 6 fill a column from here down. */
export const ANSWER_CELLS: Record<number, { sheet: string; address: string }> = {
  1: { sheet: SHEETS.consultas, address: "C4" },
  2: { sheet: SHEETS.pedidos, address: "F4" },
  3: { sheet: SHEETS.consultas, address: "C6" },
  4: { sheet: SHEETS.consultas, address: "C8" },
  5: { sheet: SHEETS.consultas, address: "C10" },
  6: { sheet: SHEETS.consultas, address: "C13" },
  7: { sheet: SHEETS.consultas, address: "C20" },
  8: { sheet: SHEETS.consultas, address: "C22" },
  9: { sheet: SHEETS.consultas, address: "C24" },
};

/** Fixed layout of the reference tables on "BX Consultas". */
export const LAYOUT = {
  pedidosLastRow: 3 + PEDIDOS.length, // header on row 3
  vendedoresFirstRow: 13,
  comisionesHeader: "G3",
  regionHeader: "G11",
} as const;

/** Excel serial number for a yyyy-mm-dd date (1900 date system). */
export function excelDate(isoDate: string): number {
  const [y, m, d] = isoDate.split("-").map(Number);
  return (Date.UTC(y, m - 1, d) - Date.UTC(1899, 11, 30)) / 86400000;
}
